import * as React from 'react';
import * as styled from './styled';
import Button, {ButtonVariant} from 'components/Button';
import {FooterProps} from './types';

/**
 * The footer part of builder component.
 * @param {React.PropsWithChildren<FooterProps>} props
 * @return {React.ReactElement<React.PropsWithChildren<FooterProps>>}
 * @constructor
 */
export default function Footer(
    props: React.PropsWithChildren<FooterProps>,
): React.ReactElement<React.PropsWithChildren<FooterProps>> {
  /**
   * Render create/update button.
   * @return {JSX.Element}
   */
  function renderSubmit(): JSX.Element {
    /**
     * Get button text.
     * @return {string}
     */
    function getText(): string {
      return props.isCreated()
        ? 'Сохранить' : 'Создать';
    }

    return (
      <Button type="submit" variant={ButtonVariant.Primary}>
        {getText()}
      </Button>
    );
  }

  return (
    <styled.Wrapper>
      <styled.Container>
        {props.children}
        {renderSubmit()}
      </styled.Container>
    </styled.Wrapper>
  );
}
